import { selectSidebarConfig,selectAnnotationFields, selectAnnotations, get_display_value, allDescriptionKeys } from '../app/annotations.js'
import { selectGetUser } from '../app/users.js'
import { useSelector } from 'react-redux'
import { niceUnitDisplayer } from '../app/helpers.js'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {selectCanDo} from "../app/auth.js"
import { useCallback, useEffect, useState } from 'react'
import { pos2InspectionCoordSys, selectCoordSys } from '../app/inspection.js'
import { selectProjectId } from '../app/projects.js'
import DeleteConfirmationModal from './DeleteConfirmationModal.jsx'
import { selectSelectedAnnotationIds } from '../app/interface.js'
import { selectTextAnnotations } from '../app/textAnnotations.js'
import { useRef } from 'react'

function SelectedAnnotation(){
  const annotationFields = useSelector(selectAnnotationFields)
  const getUser = useSelector(selectGetUser)
  const canDo = useSelector(selectCanDo)
  const [selectedAnnotations, setSelectedAnnotations] = useState([]);
  const selectedAnnotationsIds = useSelector(selectSelectedAnnotationIds)
  const annotations = useSelector(selectAnnotations)
  const textAnnotations = useSelector(selectTextAnnotations)
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false); // indicates if the "confirmation before deletion" modal is open or not
  const selectedCoordSys = useSelector(selectCoordSys)
  const projectId = useSelector(selectProjectId);  
  const deleteRef = useRef(false) // used to handle freezed state value in eventListeners
  const selectedAnnotationCountRef = useRef(0); // handles callback access to data
  const allKeys = useSelector(allDescriptionKeys)

  // using callback to prevent react creating the func again losing tracability do disable it later
  const handleKeyDown = useCallback((e) => {
    // protect from trigger when typing in annotation from
    const isTyping = (
      e.target.tagName === 'INPUT' ||
      e.target.tagName === 'TEXTAREA' ||
      e.target.isContentEditable
    );

    if (
      !isTyping && (e.key === 'Backspace' || e.key === 'Delete')
      && deleteRef.current === false && selectedAnnotationCountRef.current > 0
    ) {
      deleteRef.current = true;
      setDeleteConfirmOpen(true);
    }
  }, []);

  // event listener to handle which component is listenning
  // cases:
  //  - deletion modal is not open but there is a selection => selectedAnnotation is listenning
  //  - deletionModal is open => the modal is listenning not the selectedAnnotation
  useEffect(() => {
    if (!deleteConfirmOpen) {
      window.addEventListener('keyup', handleKeyDown);
      deleteRef.current = false;
    } else {
      window.removeEventListener('keyup', handleKeyDown);
    }
    // remove listener n dismount
    return () => {
      window.removeEventListener('keyup', handleKeyDown);
    };
  }, [deleteConfirmOpen]);
  
  // update selected annotations
  useEffect(() => {
    if (selectedAnnotationsIds && annotations) {
      const found = annotations.filter(a => selectedAnnotationsIds.includes(a.id))
      const labels = textAnnotations.filter(a => selectedAnnotationsIds.includes(a.id))
      setSelectedAnnotations(found)
      // save selection quantity for delete modal callback
      selectedAnnotationCountRef.current = found.length + labels.length;
    }
  }, [selectedAnnotationsIds, annotations, textAnnotations])

  const selectedLabels = textAnnotations.filter(a => selectedAnnotationsIds.includes(a.id))

  if (selectedLabels.length > 0 && selectedAnnotations.length === 0) {
    return <div className="annotations-selected">
      <div>
        <p>{selectedLabels.length} label{selectedLabels.length > 1 ? "s" : ""} selected</p>
      </div>
      { projectId &&
        canDo('createAnnotation', {projectId}) ?
          <DeleteConfirmationModal
            open={deleteConfirmOpen}
            setDeleteConfirmOpen={setDeleteConfirmOpen}
            annotation_count={selectedLabels.length}
            itemName="label"
          />
        : ""
      }
    </div>
  }

  if(selectedAnnotations.length === 0){
    return <div></div>
  }else{
    return (<div className="annotations-selected"> 
      <div>
        <p>{selectedAnnotations.length} annotations selected</p>
      </div>
      { selectedAnnotations.length === 1 &&
        <div>

        <div className="annotation-createdBy">
          by {selectedAnnotations[0].createdByEmail}
        </div>
        <ul style={{padding: 0}}>
          {annotationFields.keys.map((k) => {
            let value = get_display_value(k, selectedAnnotations[0], allKeys);
            return (<li key={`desc-${k.name}`}><b>{k.title}:</b>{` ${value}`}</li>)
          })}
          { selectedAnnotations.length === 1 &&
            Object.entries(pos2InspectionCoordSys(selectedCoordSys, selectedAnnotations[0].position)).map(([k, v]) => {
              return <div key={k}><b>{k === "center" ? "Center position" : k.charAt(0).toUpperCase() + k.slice(1)}</b>:
                { k === "center" ?
                  Object.entries(v).map(([k2,v2]) => {
                    return <div key={`value_${k2}`}style={{paddingLeft: "20px"}}>{`${k2}: ${niceUnitDisplayer({dist: v2.value, unit: v2.unit})}`}</div>
                  })
                :
                  `${v.value.toFixed(3)} ${v.unit}${k === "area" ? "²" : ""}`
                }
              </div>
            })
          }
        </ul>
      </div>
    }
    { projectId &&
      canDo('createAnnotation', {projectId}) ? 
        <div className="annotation-buttons">
        <DeleteConfirmationModal
          open={deleteConfirmOpen}
          setDeleteConfirmOpen={setDeleteConfirmOpen}
          annotation_count={selectedAnnotationsIds.length}
          />
        <div onClick={() => setDeleteConfirmOpen(true)}>
          <FontAwesomeIcon icon={faTrash}/> Delete
        </div>
      </div>
      :
      ""
    }
    </div>)
  }
}

export default SelectedAnnotation;